export default {
  userInfo: null,
  menus: null,
  level1CurrentIndex: 0,
  provinceList: [],
  cityList: []
};
